export default "__VITE_ASSET__CBhj6Kv2__"